import { RootState } from "store";

export const getHasValidPolicy = (state: RootState) => !!state.policy.id && !!state.policy.status;
